export default __webpack_public_path__ + "608fba3896c4fde0caaa566780fb10e5.gif";